export default __webpack_public_path__ + "a305ffe4c4dd594ea636bcf77a5cfaca.svg";